<div>
  <div class="heading animated"></div>
  <div class="title animated"></div>
</div>

<div class="details">
  <div class="label animated"></div>
  <div class="value animated"></div>
</div>

<div class="cta animated"></div>
